<template>
  <div class="sub_alfx">
    <div class="sub_search">
      <!--<a class="pic" @click="getSubReportDate"><img src="../../assets/img/search_icon.png" alt=""></a>-->
      <input
        type="text"
        :placeholder="$t('sub_index.search_plc_r')"
        v-model="keyword"
      /><a href="#" @click="getSubReportDate">{{ $t("sub_index.search") }}</a>
    </div>
    <div class="sub_list">
      <div class="sub_list_con">
        <scroll
          class="wrapper"
          :data="subReportData"
          :pulldown="pulldown"
          :pullup="pullup"
          @pulldown="getSubReportDate"
          @scrollToEnd="getSubReportDate('up')"
        >
          <ul v-if="subReportData.length != 0">
            <li class="top">
              <span></span>
              <span>{{ $t("sub_report.name") }}</span>
              <span>{{ $t("sub_report.study_dur") }}</span>
              <span>{{ $t("sub_report.credit") }}</span>
            </li>
            <li
              v-for="(item, index) in subReportData"
              :key="index"
              class="content"
            >
              <span>
                <img :src="item.avatar ? item.avatar : defaultHeadImg" alt="" />
              </span>
              <span>{{ item.username }}</span>
              <!--<span>{{item.total_time}}分钟</span>-->
              <span>{{
                item.total_time == 0
                  ? `0${$t("sub_index.minute")}`
                  : item.total_time + $t("sub_index.minute")
              }}</span>
              <span>{{
                item.total_credit == 0
                  ? `0${$t("sub_index.credits_d")}`
                  : item.total_credit + $t("sub_index.credits_d")
              }}</span>
            </li>
          </ul>
          <div class="loading-no" v-if="subReportData.length == 0">
            <span>{{ $t("sub_report.noContent") }}</span>
          </div>
          <div class="loading-wrapper" v-else v-show="pullupFlag">
            <img
              src="../../assets/img/loading.gif"
              alt=""
              v-show="pullupFlagImg"
            />{{ pullupValue }}
          </div>
        </scroll>
      </div>
    </div>
    <!--提示框-->
    <div class="model model_slide" v-show="showModel">{{ modelValue }}</div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/default.png";
import scroll from "@/components/better_scroll";
export default {
  data() {
    return {
      keyword: "", //搜索关键词
      trainplan_name: "", //计划项目名
      subReportData: [], //报表数据
      subListData: [], //报表数据暂存
      defaultHeadImg: defaultHeadImg,
      showModel: false,
      modelValue: "", //提示框内容
      study_status: 2,
      page: 1,

      pulldown: true,
      pullup: true,
      pullupFlag: false,
      pullupFlagImg: false,
      pullupValue: this.$t("sub_report.loading"),
    };
  },
  created() {
    this.getSubReportDate();
  },
  /* mounted () {
     this.$nextTick(()=> {
     this.getSubReportDate();
     })
     },*/
  components: {
    scroll,
  },
  methods: {
    getSubReportDate(e) {
      if (e == "up") {
        this.pullupFlag = true;
        this.page++;
      } else {
        this.page = 1;
        this.pullupValue = this.$t("sub_report.loading");
      }
      var _this = this;
      let url = "index.php/mobile/my-subordinate-report/user-report-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),

        page: this.page,
        size: 10,
        kw: this.keyword,
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          //            _this.subReportData=res.data.result.data;
          // console.log(res);
          if (e == "up") {
            if (_this.page <= res.data.result.pages.page_count) {
              _this.subReportData = _this.subReportData.concat(
                res.data.result.data
              );
              _this.subListData = _this.subReportData;
            } else {
              _this.pullupFlagImg = false;
              _this.pullupValue = this.$t("sub_report.noMore");
            }
          } else {
            _this.subReportData = res.data.result.data;
            _this.subListData = res.data.result.data;
          }
          // console.log(_this.subReportData);
        } else {
          this.showModel = true;
          this.modelValue = res.data.msg;
          setTimeout(() => {
            this.showModel = false;
          }, 2000);
        }
      });
    },
    loadData(e) {
      this.study_status = e;
      this.getSubReportDate();
    },
    goDetail(e) {
      this.$router.push({
        name: "sub_alfx_detail",
        query: {
          trainplan_id: e.trainplan_id,
          resources_id: e.resources_id,
          my_sub_id: e.user_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_alfx {
  height: 100%;
  font-size: 0.22rem;
  background-color: #f6f6f6;
  .sub_search {
    width: 5.4rem;
    height: 0.48rem;
    background: rgba(255, 255, 255, 1);
    /*border:1Px solid rgba(216, 216, 216, 0.85);
       */
    border-radius: 0.04rem;
    margin-bottom: 0.4rem;
    .pic {
      display: inline-block;
      float: left;
      img {
        display: inline-block;
        float: left;
        width: 0.24rem;
        height: 0.24rem;
        margin: 0.12rem 0.18rem;
      }
    }
    input {
      float: left;
      height: 0.48rem;
      width: 4.4rem;
      padding: 0.12rem 0;
      box-sizing: border-box;
      border: 1px solid rgba(216, 216, 216, 0.85);
      text-indent: 0.22rem;
      border-right: none;
      line-height: normal;
      border-radius: 0;
    }
    a {
      display: inline-block;
      height: 0.48rem;
      line-height: 0.48rem;
      width: 1rem;
      background-color: $mColor;
      color: #fff;
      text-align: center;
      border-radius: 0 0.04rem 0.04rem 0;
    }
    @include pl-color(#a9aeaf);
  }
  .sub_list {
    .sub_list_nav {
      margin-left: 0.16rem;
      span {
        margin-right: 0.48rem;
        color: #a9aeaf;
        position: relative;
        display: inline-block;
        height: 0.42rem;
        &.cur {
          color: $mColor;
          i {
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -0.14rem;
            display: inline-block;
            width: 0.28rem;
            height: 0.04rem;
            background-color: $mColor;
          }
        }
      }
    }
    .sub_list_con {
      position: relative;
      .wrapper {
        position: absolute;
        left: 0;
        top: 0.2rem;
        overflow: hidden;
        height: calc(100vh - 2.8rem);
        .loading-wrapper {
          width: 100%;
          text-align: center;
          margin: 0.24rem auto;
          height: 0.4rem;
          background-color: #f6f6f6;
          color: #000;
          padding: 0;
          font-size: 0.22rem;
          img {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            vertical-align: middle;
            margin-right: 0.2rem;
          }
        }
        .loading-no {
          width: 3.2rem;
          height: 3.2rem;
          margin: 0.2rem auto;
          border-radius: 50%;
          margin-left: 1rem;
          @include bg-image("../../assets/img/scale/sub/no-date");
          -webkit-background-size: 100%;
          background-size: 100%;
          color: #ccc;
          position: relative;
          span {
            font-size: 0.32rem;
            position: absolute;
            bottom: 0.1rem;
            left: 0.92rem;
          }
        }
      }
      ul {
        border: 1px solid rgba(220, 220, 220, 1);
        box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.05);
        li {
          width: 5.36rem;
          height: 1rem;
          line-height: 1rem;
          display: flex;
          font-size: 0.2rem;
          color: #252631;
          &.content {
            span {
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          span {
            flex: 1;
            text-align: center;
            white-space: nowrap;
            img {
              width: 0.66rem;
              height: 0.66rem;
              border-radius: 50%;
              margin-left: 0.36rem;
              margin-top: 0.18rem;
            }
          }
          &:nth-of-type(2n + 1) {
            background-color: #fff;
          }
          &:nth-of-type(1) {
            background-color: #f6f6f6;
          }
          &:nth-of-type(2) {
            background: linear-gradient(
              61deg,
              rgba(255, 212, 126, 1),
              rgba(255, 236, 159, 1)
            );
          }
          &:nth-of-type(3) {
            background: linear-gradient(
              61deg,
              rgba(181, 192, 198, 1),
              rgba(227, 231, 233, 1)
            );
          }
          &:nth-of-type(4) {
            background: linear-gradient(
              61deg,
              rgba(211, 158, 122, 1),
              rgba(240, 199, 166, 1)
            );
          }
          &.top {
            height: 0.8rem;
            line-height: 0.8rem;
            font-size: 0.22rem;
            color: $mColor;
          }
        }
      }
    }
  }
}
</style>
